// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\UserSummary\UserSummary.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// UserSummaryData is the class that UserSummary serializes to/from
export interface UserSummaryData {
    Id : number;
	
    OrganizationId : number;
	
    CanViewPilotPages : boolean;
    FirstName : string | null;
    LandingPage : string | null;
    LastName : string | null;
    OrganizationName : string | null;
    UserName : string | null;
}

// UserSummaryOptions is the class which may be passed to the UserSummary constructor to define optional initial data values
export interface UserSummaryOptions {
    Id : number;
	
    OrganizationId? : number;
	
    CanViewPilotPages? : boolean;
    FirstName? : string | null;
    LandingPage? : string | null;
    LastName? : string | null;
    OrganizationName? : string | null;
    UserName? : string | null;
}

export class UserSummary {
    public Id : DataSignal<number>;
	
    public OrganizationId : DataSignal<number>;
	
    public CanViewPilotPages : DataSignal<boolean>;
    public FirstName : DataSignal<string | null>;
    public LandingPage : DataSignal<string | null>;
    public LastName : DataSignal<string | null>;
    public OrganizationName : DataSignal<string | null>;
    public UserName : DataSignal<string | null>;

    constructor();
    constructor(data : UserSummaryOptions);
    constructor(data: UserSummaryOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.CanViewPilotPages = jsonableObservable(S.value<boolean>(data && data.CanViewPilotPages !== undefined ? data.CanViewPilotPages : false));
        this.FirstName = jsonableObservable(S.value<string | null>(data && data.FirstName !== undefined ? data.FirstName : null));
        this.LandingPage = jsonableObservable(S.value<string | null>(data && data.LandingPage !== undefined ? data.LandingPage : null));
        this.LastName = jsonableObservable(S.value<string | null>(data && data.LastName !== undefined ? data.LastName : null));
        this.OrganizationName = jsonableObservable(S.value<string | null>(data && data.OrganizationName !== undefined ? data.OrganizationName : null));
        this.UserName = jsonableObservable(S.value<string | null>(data && data.UserName !== undefined ? data.UserName : null));
    }

    static key(obj : UserSummary) {
        return obj.Id();
    }
    
    static dataKey(obj : UserSummaryOptions) {
        return obj.Id;
    }

    static update(obj : UserSummary, data : UserSummaryOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.CanViewPilotPages !== undefined) obj.CanViewPilotPages(data.CanViewPilotPages);
            if (data.FirstName !== undefined) obj.FirstName(data.FirstName);
            if (data.LandingPage !== undefined) obj.LandingPage(data.LandingPage);
            if (data.LastName !== undefined) obj.LastName(data.LastName);
            if (data.OrganizationName !== undefined) obj.OrganizationName(data.OrganizationName);
            if (data.UserName !== undefined) obj.UserName(data.UserName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/UserSummary.ts